import { apiClient } from './api.client';
import type { components } from '../types/api.generated';
import { handleApiResponse, handleApiArrayResponse } from './apiHelpers';

export type Contribution = components['schemas']['Contribution'];
export type CreateContributionRequest = components['schemas']['CreateContributionRequest'];

export const contributionService = {
  /**
   * Get all contributions
   */
  async list() {
    const response = await apiClient.GET('/contributions');
    return handleApiArrayResponse<Contribution>(response as any);
  },

  /**
   * Get contribution by ID
   */
  async get(id: string) {
    const response = await apiClient.GET('/contributions/{id}', {
      params: { path: { id } }
    });
    return handleApiResponse<Contribution>(response as any);
  },

  /**
   * Create new contribution
   */
  async create(contribution: CreateContributionRequest) {
    const response = await apiClient.POST('/contributions', {
      body: contribution
    });
    return handleApiResponse<Contribution>(response as any);
  },

  /**
   * Update contribution
   */
  async update(id: string, contribution: CreateContributionRequest) {
    const response = await apiClient.PUT('/contributions/{id}', {
      params: { path: { id } },
      body: contribution
    });
    return handleApiResponse<Contribution>(response as any);
  },

  /**
   * Confirm contribution (treasurer/board only)
   */
  async confirm(id: string) {
    const response = await apiClient.POST('/contributions/{id}/confirm', {
      params: { path: { id } }
    });
    return handleApiResponse<Contribution>(response as any);
  },

  /**
   * Delete contribution - Not supported by backend API
   */
  async delete(_id: string) {
    throw new Error('Delete contribution operation is not supported by the backend API');
  }
};
